var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83333 9C2.29357 9 2.66667 8.6269 2.66667 8.16667C2.66667 7.70643 2.29357 7.33333 1.83333 7.33333C1.3731 7.33333 1 7.70643 1 8.16667C1 8.6269 1.3731 9 1.83333 9Z",
    fill: "#464D48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83333 3.16667C2.29357 3.16667 2.66667 2.79357 2.66667 2.33333C2.66667 1.8731 2.29357 1.5 1.83333 1.5C1.3731 1.5 1 1.8731 1 2.33333C1 2.79357 1.3731 3.16667 1.83333 3.16667Z",
    fill: "#464D48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83333 14.8333C2.29357 14.8333 2.66667 14.4602 2.66667 14C2.66667 13.5398 2.29357 13.1667 1.83333 13.1667C1.3731 13.1667 1 13.5398 1 14C1 14.4602 1.3731 14.8333 1.83333 14.8333Z",
    fill: "#464D48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49996 9C6.9602 9 7.33329 8.6269 7.33329 8.16667C7.33329 7.70643 6.9602 7.33333 6.49996 7.33333C6.03972 7.33333 5.66663 7.70643 5.66663 8.16667C5.66663 8.6269 6.03972 9 6.49996 9Z",
    fill: "#464D48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49996 3.16667C6.9602 3.16667 7.33329 2.79357 7.33329 2.33333C7.33329 1.8731 6.9602 1.5 6.49996 1.5C6.03972 1.5 5.66663 1.8731 5.66663 2.33333C5.66663 2.79357 6.03972 3.16667 6.49996 3.16667Z",
    fill: "#464D48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49996 14.8333C6.9602 14.8333 7.33329 14.4602 7.33329 14C7.33329 13.5398 6.9602 13.1667 6.49996 13.1667C6.03972 13.1667 5.66663 13.5398 5.66663 14C5.66663 14.4602 6.03972 14.8333 6.49996 14.8333Z",
    fill: "#464D48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83333 9C2.29357 9 2.66667 8.6269 2.66667 8.16667C2.66667 7.70643 2.29357 7.33333 1.83333 7.33333C1.3731 7.33333 1 7.70643 1 8.16667C1 8.6269 1.3731 9 1.83333 9Z",
    stroke: "#464D48",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83333 3.16667C2.29357 3.16667 2.66667 2.79357 2.66667 2.33333C2.66667 1.8731 2.29357 1.5 1.83333 1.5C1.3731 1.5 1 1.8731 1 2.33333C1 2.79357 1.3731 3.16667 1.83333 3.16667Z",
    stroke: "#464D48",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83333 14.8333C2.29357 14.8333 2.66667 14.4602 2.66667 14C2.66667 13.5398 2.29357 13.1667 1.83333 13.1667C1.3731 13.1667 1 13.5398 1 14C1 14.4602 1.3731 14.8333 1.83333 14.8333Z",
    stroke: "#464D48",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49996 9C6.9602 9 7.33329 8.6269 7.33329 8.16667C7.33329 7.70643 6.9602 7.33333 6.49996 7.33333C6.03972 7.33333 5.66663 7.70643 5.66663 8.16667C5.66663 8.6269 6.03972 9 6.49996 9Z",
    stroke: "#464D48",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49996 3.16667C6.9602 3.16667 7.33329 2.79357 7.33329 2.33333C7.33329 1.8731 6.9602 1.5 6.49996 1.5C6.03972 1.5 5.66663 1.8731 5.66663 2.33333C5.66663 2.79357 6.03972 3.16667 6.49996 3.16667Z",
    stroke: "#464D48",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49996 14.8333C6.9602 14.8333 7.33329 14.4602 7.33329 14C7.33329 13.5398 6.9602 13.1667 6.49996 13.1667C6.03972 13.1667 5.66663 13.5398 5.66663 14C5.66663 14.4602 6.03972 14.8333 6.49996 14.8333Z",
    stroke: "#464D48",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/drag-icon.5f8c365b5cab90ab89a68ffbf16d7bb1.svg";
export { ForwardRef as ReactComponent };